<template>
	<div class="settings">
		<div class="settings__header">
			<h1><i class="fas fa-cog"></i>Settings</h1>
		</div>
		<div class="settings__content">
			<div class="settings__content__menu">
				<button
					v-for="page in pages"
					:key="page.name"
					class="settings__content__menu__link"
					:class="{'settings__content__menu__link--selected': activePage === page.name}"
					@click="activePage = page.name">
					{{page.name}}
				</button>
			</div>
			<div class="settings__content__section">
				<h2 class="settings__content__section__header">{{activePage}}
					<button
						class="settings__save"
						:class="{'settings__save--disabled': !settingsChanged}"
						@click="saveSettings">
						Save changes
					</button>
				</h2>
				<span v-if="activePage === 'Account'">
					<label>Username</label>
					<br>
					<input class="settings__content__input" v-model="user.username">
					<br>
					<label>New password</label>
					<br>
					<input class="settings__content__input" v-model="user.password" type="password" autocomplete="new-password">
					<br>
					<label>Confirm new password</label>
					<br>
					<input class="settings__content__input" v-model="user.password_confirm" type="password" autocomplete="new-password">
				</span>
				<span v-else-if="activePage === 'Profile'">
					<label>First name</label>
					<br>
					<input class="settings__content__input" v-model="user.first_name">
					<br>
					<label>Last name</label>
					<br>
					<input class="settings__content__input" v-model="user.last_name">
					<br>
					<label>School</label>
					<Dropdown
						class="settings__content__dropdown"
						:placeholder="'School'"
						:options="schools"
						:labels="schools.map(school => school.name)"
						v-model="user.School">
					</Dropdown>
					<label v-if="user.School">Program</label>
					<Dropdown
						v-if="user.School"
						:brick="true"
						:placeholder="'Program'"
						:options="programs"
						:labels="programs.map(program => program.title)"
						v-model="user.Program">
					</Dropdown>
				</span>
				<span v-else-if="activePage === 'Notifications'">
				</span>
				<span v-else-if="activePage === 'Application'">
					<button
						class="settings__darkmode"
						@click="toggleDarkMode()">
						<span	v-if="darkMode">
							<i class="fas fa-sun"></i>
							Switch to light mode
						</span>
						<span	v-else>
							<i class="fas fa-moon"></i>
							Switch to dark mode
						</span>
					</button>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileService from '@/services/ProfileService'
import SchoolService from '@/services/SchoolService'
import Dropdown from '@/components/Dropdown'
export default {
	components: {
		Dropdown
	},
	data () {
		return {
			activePage: 'Account',
			pages: [{ name: 'Account' }, { name: 'Profile' }, { name: 'Notifications' }, { name: 'Application' }],
			schools: [],
			programs: [],
			user: {
				School: null,
				Program: null
			},
			setup: false
		}
	},
	methods: {
		toggleDarkMode () {
			this.$store.dispatch('toggleDarkMode')
		},
		async getSchools () {
			this.schools = await SchoolService.getSchools()
		},
		async getPrograms () {
			this.programs = await SchoolService.getPrograms(this.user.School.id)
		},
		async runSetup () {
			this.user = JSON.parse(JSON.stringify(this.$store.state.authentication.user))
			await this.getSchools()
			if (this.user.School) {
				// Set school
				const schoolId = this.user.School.id
				this.user.School = this.schools.find(school => school.id === schoolId)
				await this.getPrograms()
				if (this.user.Program) {
					// Set program
					const programId = this.user.Program.id
					this.user.Program = this.programs.find(program => program.id === programId)
				}
			}
			this.setup = true
		},
		async saveSettings () {
			if (this.settingsChanged) {
				if (this.user.password) {
					if (this.user.password.length < 6) {
						this.$store.dispatch('openPopup', { title: 'Account update', message: 'Password must be at least 6 characters.'	})
						return
					}
					if (this.user.password !== this.user.password_confirm) {
						this.$store.dispatch('openPopup', { title: 'Account update', message: 'The entered passwords do not match.'	})
						return
					}
				}
				await ProfileService.edit(this.user)
				await this.$store.dispatch('updateUser', this.user)
				this.user.password = null
				this.user.password_confirm = null
			}
		}
	},
	watch: {
		'user.School' () {
			if (this.setup) {
				this.user.Program = null
				this.getPrograms()
			}
		}
	},
	computed: {
		darkMode () {
			return this.$store.state.settings.darkMode
		},
		settingsChanged () {
			let settingsChanged = false
			let current = this.$store.state.authentication.user
			let updated = this.user
			switch (this.activePage) {
			case 'Account':
				if (updated.username !== current.username) settingsChanged = true
				if (updated.password) settingsChanged = true
				if (updated.password_confirm) settingsChanged = true
				break
			case 'Profile':
				if (updated.first_name !== current.first_name) settingsChanged = true
				if (updated.last_name !== current.last_name) settingsChanged = true
				if (!updated.Program || !current.Program) {
					if (updated.Program || current.Program) settingsChanged = true
				} else if (updated.Program.id !== current.Program.id) settingsChanged = true
				break
			case 'Notifications':
				break
			case 'Application':
				break
			}
			return settingsChanged
		}
	},
	async created () {
		this.runSetup()
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/views/_settings.scss';
</style>
